import App from "./App";

window.barba = new App();
